import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'
import classNames from 'classnames'

import styles from 'components/form/form-style'

import { isInputWithError } from 'helpers/form'

const getErrorMessages = (meta, t) => {
  const messages = [];

  (meta.error || []).forEach(error =>
    messages.push(getErrorMessage(error, t))
  );

  (meta.submitError || []).forEach(error =>
    messages.push(error) // server errors are already translated
  );

  return messages
}

const getErrorMessage = (error, t) => {
  let message

  if (error.options && error.options.i18nError) {
    message = t(error.options.i18nError)
  } else {
    message = t(error.code)
  }

  for(let key in error.options) {
    message = message.replace(`%{${key}}`, error.options[key])
  }

  return message
}

const InputError = props => {
  const classes = styles(props.theme)

  if (!isInputWithError(props.meta)) return null

  const errorClassNames = classNames(classes.error, 'input-error', props.className, {
    [classes.errorLeft]: props.direction === 'left'
  })

  return <span className={errorClassNames}>{getErrorMessages(props.meta, props.t).join(', ')}</span>
}

InputError.propTypes = {
  theme: PropTypes.object.isRequired,
  meta: PropTypes.object,
  className: PropTypes.string,
}

export default compose(
  withTranslation(),
  withTheme,
)(InputError)
